import {
  Button,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Card,
  CardBody,
  CardHeader,
  Heading,
  useDisclosure,
  Text,
  Spacer,
  useBoolean,
  Divider,
  useToast,
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { ConfirmModal } from "../components";
import KhungGiaDatDetail from "../containers/KhungGiaDatDetail";
import { useCallback, useEffect, useState } from "react";
import { AppAction, IKhungGiaDat } from "../_types_";
import { getKhungGiaDat, saveKhungGiaDat } from "../apis/giadat.api";
import { getToast, showDate } from "../utils";
import SearchContainer from "../components/SearchContainer";
import { useGlobal } from "../contexts/Globals";

export interface IProps {}

const BangGiaDat = () => {
  const { isHasEditRole } = useGlobal();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [flag, setFlag] = useBoolean();
  const [giaDats, setGiaDats] = useState<IKhungGiaDat[]>([]);
  const [model, setModel] = useState<IKhungGiaDat>();
  const toast = useToast();

  const handleAddOrEdit = useCallback(
    (m: IKhungGiaDat | undefined) => {
      if (m) {
        setModel({ ...m, action: AppAction.EDIT });
      } else {
        setModel(undefined);
      }
      setFlag.on();
    },
    [setFlag]
  );

  const initData = useCallback(async (search?: string, isHis = false) => {
    const mdResult = await getKhungGiaDat(1, 50, isHis, search);
    setGiaDats(mdResult?.items || []);
  }, []);

  useEffect(() => {
    initData();
  }, [isOpen, flag, initData]);

  const handleSaveChange = useCallback(
    async (model: IKhungGiaDat) => {
      try {
        const request = [model];
        await saveKhungGiaDat(request);
        setModel(undefined);
        toast(
          getToast(
            `${
              model.action === AppAction.DELETE
                ? "Xoá"
                : model.action === AppAction.EDIT
                ? "Sửa"
                : "Thêm"
            } khung giá đất thành công.`,
            "success",
            "Thông tin"
          )
        );
        await initData();
        setFlag.off();
      } catch (er) {
        toast(getToast(`${er}`, "error"));
      }
    },
    [initData, setFlag, toast]
  );

  return (
    <Flex w="full" bg="whiteAlpha.900" overflow="auto" paddingBottom="10px">
      <Card w="full">
        <CardHeader>
          <Flex>
            <Heading as="h3" textTransform='uppercase'>Khung Giá Đất</Heading>
            <Spacer />
            {isHasEditRole && (
              <Button
                bg="green"
                size="sm"
                onClick={() => handleAddOrEdit(undefined)}
              >
                <AddIcon color="white" />
                <Text ml="10px" color="white">
                  Thêm khung giá đất
                </Text>
              </Button>
            )}
          </Flex>
          <Flex w="full" justifyContent="flex-end">
            <SearchContainer
              placeholder="Tìm theo mã loại đất"
              onSearch={(e, b) => initData(e, b)}
            />
          </Flex>
          <Divider pb="15px" />
        </CardHeader>
        <CardBody>
          <TableContainer w="full">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Khu vực</Th>
                  <Th>Loại đất</Th>
                  <Th>Vị trí</Th>
                  <Th>Giá tiền</Th>
                  <Th>Ngày hiệu lực</Th>
                  <Th>Ngày hết hiệu lực</Th>
                  {isHasEditRole && <Th>#</Th>}
                </Tr>
              </Thead>
              <Tbody>
                {giaDats.map((giaDat) => (
                  <Tr key={giaDat.id}>
                    <Td>{giaDat.khuVuc}</Td>
                    <Td>{giaDat.loaiDat}</Td>
                    <Td>{giaDat.vitri}</Td>
                    <Td>{giaDat.giaTien}</Td>
                    <Td>{showDate(giaDat.hieuLuc)}</Td>
                    <Td>{showDate(giaDat.hetHieuLuc)}</Td>
                    {isHasEditRole && (
                      <Td>
                        <Button
                          bg="red.300"
                          size="sm"
                          onClick={() => {
                            setModel({ ...giaDat, action: AppAction.DELETE });
                            onOpen();
                          }}
                        >
                          <DeleteIcon color="white" />
                        </Button>
                        <Button
                          bg="blue.300"
                          size="sm"
                          marginLeft="10px"
                          onClick={() => handleAddOrEdit(giaDat)}
                        >
                          <EditIcon color="white" />
                        </Button>
                      </Td>
                    )}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
      <ConfirmModal
        isOpen={isOpen}
        onClose={onClose}
        onOk={() => {
          if (model && model.action === AppAction.DELETE) {
            onClose();
            handleSaveChange(model);
          }
        }}
      />
      <KhungGiaDatDetail
        isOpen={flag}
        onClose={() => setFlag.off()}
        model={model}
        onSave={(m) => handleSaveChange(m)}
      />
    </Flex>
  );
};

export default BangGiaDat;
